import { titulosApi } from "../view/titulos.service";

export const cancelTitulo = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    cancelTitulo: builder.mutation({
      query: (id) => ({
        url: `/v1/api/titulo/${id}/cancel/`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Titulos", id }, { type: "Titulos", id: "LIST" }],
    }),
  }),
});

export const { useCancelTituloMutation } = cancelTitulo;
